/**
 * Loyalty block on payment step
 */
import Component from '_core_ext/components/Component';
import ajax from '_core_ext/ajax';
import eventMgr from '_core_ext/eventMgr';
import {showLoader} from './benefitsLoader';

const emitter = eventMgr.getEmitter('LoyaltyBlock');
const blockSelector = '.js-loyalty-block';

export default class LoyaltyBlock extends Component {
    static get selector() {
        return blockSelector;
    }

    init(...args) {
        super.init(...args);

        this.onRedeemBalance = this.onRedeemBalance.bind(this);
        this.onRemoveRedemtpion = this.onRemoveRedemtpion.bind(this);

        this.initEvents();
    }

    initEvents() {
        this.event('click', '.js-loyalty-redeem', this.onRedeemBalance);
        this.event('keypress', '.js-input-amount', this.onEnterPressed.bind(null, this.onRedeemBalance));
        this.event('click', '.js-remove-redemption', this.onRemoveRedemtpion);
    }

    reInitComponents() {
        app.components.initComponent('RedesignInput', this.$el);
    }

    onRedeemBalance() {
        const $fieldset = this.$el.find('.js-loyalty-fieldset');
        if (!this.validateAmount($fieldset)) {
            return;
        }

        showLoader();

        ajax.load({
            url: this.config.redeemUrl,
            target: blockSelector,
            data: this.$el.find('input').serialize(),
            callback: () => {
                this.reInitComponents();
                if (this.$el.find('.js-redeemed-text').length) {
                    emitter.emit('redeemed');
                }
            },
        });
    }

    onEnterPressed(cb, input, event) {
        //If enter is pressed
        if (event.which === 13) {
            cb();
            return false;
        }
    }

    onRemoveRedemtpion(link, event) {
        event.preventDefault();
        showLoader();

        ajax.load({
            url: link.href,
            target: blockSelector,
            callback: () => {
                this.reInitComponents();
                if (this.$el.find('.js-loyalty-points-removed').length) {
                    emitter.emit('removed');
                }
            },
        });
    }

   /**
     * Check if 'Redeem loyalty' fields filled properly. 
     * Have to apply validation rules just for the moment of submitting data,
     * as form is inline, and when expanded but not filled - will prevent entire Payment page submission
     * @param {jQuery} fieldset
     * @returns {boolean}
     */
    validateAmount(fieldset) {
        var $amount = fieldset.find('#loyalty_amount');
        $amount.rules('add', {
            required: true,
            'js-input-money': true,
            min: +$amount.data('min'),
            max: +$amount.data('max')
        });
        var result = $amount.valid();
        $amount.rules('remove', 'required min max js-input-money');

        return result;
    }
}

module.exports = LoyaltyBlock;
